<app-modal [open]="active" [name]="'counter-offer'" (close)="closeDialog()">
  <div modal-header>Counter the Offered Price</div>
  <div modal-body>
    <p class="counter-offer-dialog__intro">
      Staffing weighs your price at award. Countering is not a decline — you stay in consideration.
    </p>
    <div class="form-field">
      <label class="form-label" for="counter-offer-fee">Your price</label>
      <div class="counter-offer-dialog__money">
        <span class="counter-offer-dialog__money-prefix" aria-hidden="true">$</span>
        <!--
          🔴 type="text" with inputmode="numeric", NOT type="number". The server takes counterFee as a
          Java Integer, so cents are truncated by Jackson with no error - a PA typing 2150.75 would be
          silently bid at 2150. A number input cannot prevent that: it accepts a decimal point, a paste,
          and the spinner. Sanitising every input event is what actually makes cents untypeable.
        -->
        <!--
          No placeholder. A "0" placeholder here read as a VALUE rather than a hint, because the
          adjacent $ prefix completes it: the empty field looked pre-filled with zero, next to an
          error saying the price had to be greater than zero. An empty currency field with a $
          adornment already reads as empty.
        -->
        <input
          id="counter-offer-fee"
          class="input"
          type="text"
          inputmode="numeric"
          autocomplete="off"
          data-testid="counter-offer-fee"
          [ngModel]="counterFee"
          (input)="onFeeInput($event)"
          (blur)="feeTouched = true"
        />
      </div>
      <span class="counter-offer-dialog__hint">
        Offered {{ offeredFee | currency : "USD" : "symbol" : "1.0-0" }}
      </span>
      <!--
        feeError, NOT feeInvalid. feeInvalid is true for the null the field starts at, so gating the
        message on it showed an error the moment the dialog opened. feeError adds "and the PA has
        touched the field". The submit guard still uses feeInvalid, so an untouched empty field is
        refused either way - it just is not shouted about first.
      -->
      <span
        class="counter-offer-dialog__error"
        data-testid="counter-offer-fee-error"
        *ngIf="feeError"
      >
        Enter a counter price greater than $0.
      </span>
    </div>
    <div class="form-field">
      <label class="form-label" for="counter-offer-complete-by">
        I can complete by <span class="counter-offer-dialog__optional">(optional)</span>
      </label>
      <input
        id="counter-offer-complete-by"
        class="input"
        type="date"
        data-testid="counter-offer-complete-by"
        [(ngModel)]="counterCompleteBy"
      />
    </div>
    <div class="form-field">
      <label class="form-label" for="counter-offer-note">
        Note <span class="counter-offer-dialog__optional">(optional)</span>
      </label>
      <textarea
        id="counter-offer-note"
        class="input counter-offer-dialog__note"
        rows="3"
        [attr.maxlength]="maxNoteLength"
        data-testid="counter-offer-note"
        [(ngModel)]="counterNote"
      ></textarea>
      <span class="counter-offer-dialog__char-count">
        {{ counterNote.length }} / {{ maxNoteLength }}
      </span>
      <span
        class="counter-offer-dialog__error"
        data-testid="counter-offer-note-error"
        *ngIf="noteTooLong"
      >
        Note is too long — trim it to {{ maxNoteLength }} characters.
      </span>
    </div>
    <div
      class="counter-offer-dialog__summary"
      *ngIf="siteType || address?.streetAddress?.length > 0 || address?.cityStateZip?.length > 0"
    >
      <div class="counter-offer-dialog__summary-item" *ngIf="siteType">
        <p class="counter-offer-dialog__summary-label">Service Type</p>
        <p class="counter-offer-dialog__summary-value">
          {{ siteSubType ? siteType + " - " + siteSubType : siteType }}
        </p>
      </div>
      <div
        class="counter-offer-dialog__summary-item"
        *ngIf="address?.streetAddress?.length > 0 || address?.cityStateZip?.length > 0"
      >
        <p class="counter-offer-dialog__summary-label">Location</p>
        <p class="counter-offer-dialog__summary-value">
          <span *ngIf="address?.streetAddress">{{ address?.streetAddress }}<br /></span
          >{{ address?.cityStateZip }}
        </p>
      </div>
    </div>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="counter-offer-confirm"
    [disabled]="!isValid"
    (click)="submit()"
  >
    Submit Counter
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="counter-offer-cancel"
    (click)="closeDialog()"
  >
    Cancel
  </button>
</app-modal>
